import React from 'react'

import { Row, Col } from '_zari/core'

import * as Portlets from './portlets'

const ReportePage = () => {
  return (
    <>
      <Row>
        <Col md={6}>
          <Portlets.EstandarPortlet />
        </Col>
      </Row>
    </>
  )
}

export default ReportePage
